/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Sandbox {
    angular.module("meevo.plugins.sandbox", []);
}